import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";

import type { INavigationModal, INavigationModalActions } from "../common/NavigationModal";
import { NavigationModal } from "../common/NavigationModal";
import type { ICashbackAdBanner } from "./CashbackCommonInterfaces";
import type { ICashbackWithdrawForm } from "./CashbackWithdrawForm";
import { CashbackWithdrawForm } from "./CashbackWithdrawForm";
import type { ICashbackWithdrawSuccessPage } from "./CashbackWithdrawSuccessPage";
import { CashbackWithdrawSuccessPage } from "./CashbackWithdrawSuccessPage";

import * as css from "./CashbackWithdraw.module.css";

export interface ICashbackWithdraw {
    step1?: ICashbackWithdrawForm;
    step2?: ICashbackWithdrawSuccessPage;
    navigationModal?: INavigationModal;
}

export const CashbackWithdraw = memo((props: ICashbackWithdraw) => {
    const step1 = {
        ...props.step1,
    } as ICashbackWithdrawForm;

    const step2 = {
        ...props.step2,
    } as ICashbackWithdrawSuccessPage;

    const WrapperNavigationModal = NavigationModal<
        ICashbackAdBanner,
        INavigationModalActions<ICashbackAdBanner>
    >([CashbackWithdrawForm, CashbackWithdrawSuccessPage], [step1, step2]);

    return (
        <div className={css.cashbackWithdrawComponent}>
            <WrapperNavigationModal {...props.navigationModal} />
        </div>
    );
}, defaultToTrue);
